import { createResourceCollection } from '../request'
import { Utility } from '@/types'

export const utilityCollection = createResourceCollection<Utility>({
  name: 'utilityCollection',
  apiConfig: {
    path: 'utilities',
  },
  selector: (state) => state.utilityCollection,
})

const utilityReducer = utilityCollection.slice.reducer

export default utilityReducer
